module.exports = __webpack_public_path__ + "img/illustration-mailbox-empty-state@2x.852cec35.png";